var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _CareGiverAddedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import ReferentLabUpdatedJournalEvent from "./referent-lab-updated-journal-event";
const CareGiverRoles = ["historicNurse", "relative", "psad", "pharmacist", "medicalDoctor", "psychiatrist", "diabetologist-endocrinologist", "psychologist", "physiotherapist", "analistique-laboratory", "radiotherapist", "surgeon", "gynecologist", "doctor", "nurse", "caregiver", "analistique-laboratory", "attending-surgeon", "analistique-laboratory", "acupuncturist", "administrative", "algologist", "anaesthetist", "angiologist", "anatomopathologist", "social-worker", "association", "cardiologist", "pathway-coordinator", "dietician", "endocrinologist", "gynecologist", "homeopath", "hypnotherapist", "magnetizer", "esthetics-and-laser-doctor", "geriatrician-doctor", "nuclear-doctor", "naturopath", "nephrologist", "nutritionist", "oncologist", "osteopath", "pulmonologist", "radiologist", "reflexologist", "midwife", "surgery-secretariat", "oncology-secretariat", "sexologist", "socio-esthetician", "sophrologist", "dermograph-tattooer", "provider", "dental-surgeon", "nurse-coordinator", "announcement-nurse", "mim", "biologist", "private-nurse", "other"];
export { CareGiverRoles };

//---- Automatically generated, don't update this part ----
let CareGiverAddedJournalEvent = (_dec = attr("string"), _dec2 = attr("string"), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr("string"), _dec6 = attr("string"), _dec7 = belongsTo("referent-lab-updated-journal-event", {
  async: false,
  inverse: "careGiverAddedJournalEvent"
}), _dec8 = belongsTo("patient", {
  async: false,
  inverse: "careGiverAddedJournalEvents"
}), _class = (_CareGiverAddedJournalEvent = class CareGiverAddedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "firstName", _descriptor, this);
    _initializerDefineProperty(this, "lastName", _descriptor2, this);
    _initializerDefineProperty(this, "phone", _descriptor3, this);
    _initializerDefineProperty(this, "email", _descriptor4, this);
    _initializerDefineProperty(this, "address", _descriptor5, this);
    _initializerDefineProperty(this, "role", _descriptor6, this);
    _initializerDefineProperty(this, "referentLabUpdatedJournalEvent", _descriptor7, this);
    _initializerDefineProperty(this, "patient", _descriptor8, this);
  }
  static validations(intl) {
    return {
      lastName: validatePresence({
        presence: true,
        description: intl.t("validations.care-giver-added-journal-event.last-name")
      }),
      role: validatePresence({
        presence: true,
        description: intl.t("validations.care-giver-added-journal-event.role")
      }),
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.care-giver-added-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })]
    };
  }

  //---- End of generated code ----

  get isValidLaboratory() {
    return this.role == "analistique-laboratory" && Boolean(this.phone);
  }
}, _defineProperty(_CareGiverAddedJournalEvent, "type", "care-giver-added-journal-event"), _CareGiverAddedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "firstName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "lastName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "phone", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "email", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "address", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "role", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "referentLabUpdatedJournalEvent", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CareGiverAddedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.